import { render, staticRenderFns } from "./MarketingCampaignEdit.vue?vue&type=template&id=22abcbe3&scoped=true&"
import script from "./MarketingCampaignEdit.vue?vue&type=script&lang=js&"
export * from "./MarketingCampaignEdit.vue?vue&type=script&lang=js&"
import style0 from "./MarketingCampaignEdit.vue?vue&type=style&index=0&id=22abcbe3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22abcbe3",
  null
  
)

export default component.exports